import { LayoutGridItem } from '@cko/primitives';
import styled from 'styled-components';

export const LayoutGridItemWithDivider = styled(LayoutGridItem)`
  border-bottom: var(--border-b-seed) solid var(--base-border-secondary);
`;
